export default "__VITE_ASSET__CavYOCut__"